// Create a task (E7.2), owned by hand: quick create is a dialog over the list (R1 shell-new-task), so this route — the
// shell's New task and the apps' LinkResolver key — opens the list with the dialog, keeping `teamId`. `taskId` stays in
// the route key; editing an existing task is the task's own edit. `title` is the web's own (the palette's New task with
// the search, A18U6): the apps' route key does not carry it.
import { createFileRoute, redirect } from '@tanstack/react-router'
import { text } from '../../../../shared/routing/search'

export const Route = createFileRoute('/o/$orgSlug/tasks/new')({
  staticData: { screenId: 'TaskEditScreen', access: 'task.create or task.update.*' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { taskId?: string; teamId?: string; title?: string } => ({
    taskId: text(search.taskId),
    teamId: text(search.teamId),
    title: text(search.title),
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/o/$orgSlug/tasks',
      params,
      search: { new: true, newTitle: search.title, newTeam: search.teamId },
      replace: true,
    })
  },
})
